export default __webpack_public_path__ + "static/media/DSCN2186.2a989ff9.jpg";